import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

// Re-export from centralized styles for backwards compatibility
export {
  // Typography
  headerStyle,
  detailHeaderStyle,
  detailTextStyle,
  entityTextStyle as orgTextStyle,
  textStyle as textStyles,
  overlayTextStyle as overlayTextStyles,
  // Containers
  boxContainerStyles,
  alertBoxStyles as boxStyles,
  gridContainerStyles,
  gridToolbarContainerStyles,
  buttonContainerStyles,
  popoverStyles,
  dialogContentWrapperStyles as dialogContentStyles,
  gridStyles,
  // TextFields
  FormTextField as OrganizationTextField,
  // Buttons
  SaveButton,
  CreateButton,
  HeaderButton,
  deleteButtonStyles,
  deleteIconStyles,
  // Info sections
  InfoBox,
  InfoRow,
  InfoLabel,
  InfoValueWrapper,
  InfoValue,
  StyledLinkBlue as StyledLink,
  Underline,
  CityStateZipRow,
  DetailsCard as OrganizationsCard,
  DetailsBox as OrgDetailsBox,
  CompanyLabelChip,
} from 'styles/utilities'

// Leads-specific styled components
export const PhoneRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2),
  position: 'relative',
}))

export const dataGridStyles = {}

/**
 * Dialog styles for Leads
 */
export const dialogStyles = (theme: { palette: { mode: string } }) => ({
  width: '100%',
  maxWidth: '800px',
  backgroundColor: theme.palette.mode === 'dark' ? '' : 'rgb(236, 239, 248)',
  color: '#fff',
  minHeight: '50vh',
  maxHeight: '95vh',
  padding: '20px',
  '& .MuiDialogContent-root': {
    width: '100%',
    padding: '20px',
  },
  '& .MuiTextField-root': {
    margin: '10px 0',
    flex: '1 1 45%',
    minWidth: '150px',
  },
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgb(67, 70, 75)' : 'rgba(255,255,255,1)',
    minWidth: '150px',
    flex: '1 1 45%',
  },
  '& .MuiSelect-root': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgb(67, 70, 75)' : 'rgba(255,255,255,1)',
    flex: '1 1 45%',
    minWidth: '150px',
  },
})
